import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { PermissionProvider } from './context/PermissionContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Replace with your desired color
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <PermissionProvider>
      <App />
    </PermissionProvider>
  </ThemeProvider>,
  document.getElementById('root')
);

